var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video-player',{ref:"videoPlayer",staticClass:"vjs-big-play-centered",staticStyle:{"border":"3px solid #162b44"},attrs:{"playsinline":true,"options":_vm.playerOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }